import { Modal } from '@startuptools/ui/Modal';
import { ModalDialog } from '@startuptools/ui/ModalDialog';
import { ModalClose } from '@startuptools/ui/ModalClose';
import { Typography } from '@startuptools/ui/Typography';
import { Snackbar } from '@startuptools/ui/Snackbar';
import { AddInvestment } from './AddInvestment';
import { AssignInvestors } from './AssignInvestors';
import { type InvestmentRound } from './types';
import React from 'react';
import { Trans } from '@lingui/react';
import { CapTableDocument, useCreateCapTableStakesMutation } from '../cap-table.graphql';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { identityToInput } from '@startuptools/business-ui/identity/identity-to-input';
import { StakeKind } from '@startuptools/common/cap-table';
import { BigNumber } from 'bignumber.js';
import { type GqlCapTable } from '../../..//graphql/base-types.graphql';

export const InvestmentRoundDialog = ({
  close,
  capTable,
}: {
  close: () => void;
  capTable: Pick<GqlCapTable, 'id' | 'currentShareCount' | 'pricePerShare'>;
}) => {
  const [investmentRound, setInvestmentRound] = React.useState<InvestmentRound | null>(null);
  const companyId = useCompanyId();
  const [create, { loading, error }] = useCreateCapTableStakesMutation({
    refetchQueries: [{ query: CapTableDocument, variables: { id: capTable.id, companyId } }],
  });
  const [showSnackBar, setShowSnackBar] = React.useState(false);
  if (showSnackBar)
    return (
      <Snackbar open={showSnackBar} variant="solid" color="success" onClose={close}>
        <Trans id="Success! Investment round added." />
      </Snackbar>
    );
  return (
    <>
      <Modal open onClose={close}>
        <ModalDialog size="md" sx={{ maxHeight: '90vh', overflow: 'auto' }}>
          <ModalClose />
          <Typography>
            <Trans id="Add investment" />
          </Typography>
          {!investmentRound && (
            <AddInvestment
              capTable={capTable}
              onSubmit={round => {
                setInvestmentRound(round);
              }}
            />
          )}

          {investmentRound && (
            <AssignInvestors
              loading={loading}
              error={Boolean(error)}
              round={investmentRound}
              onSave={async rows => {
                await create({
                  variables: {
                    companyId,
                    input: {
                      stakes: rows.map(r => {
                        return {
                          capTableId: capTable.id,
                          stake: r.stake,
                          name: investmentRound.name,
                          identityInput: identityToInput(r.identity),
                          kind: StakeKind.Shares,
                          comment: '',
                          acqCost: new BigNumber(r.stake).times(investmentRound.pricePerShare).toString(),
                        };
                      }),
                    },
                  },
                });
                setShowSnackBar(true);
              }}
            />
          )}
        </ModalDialog>
      </Modal>
    </>
  );
};
